module.exports = "/_next/static/images/e4a5b7bd92ee87262400370c64fb86df-medium-nyt.png";